<footer>
  <div class="right-section">
    <a routerLink="/about-us">درباره ما</a>
    <a routerLink="/terms">قوانین و مقررات</a>
    <a href="https://sheyda.com/download">دریافت اپلیکیشن های شیدا</a>
  </div>
  <div class="left-section">
    <a class="call-us" href="tel:90002908">
      <mat-icon fontSet="mat-symbol-round-fill">call</mat-icon>
      <span>90002908</span>
    </a>
    <a class="social-button" href="https://www.instagram.com/sheyda.vod" target="_blank">
      <app-image-generator src="/images/icons/instagram.svg" name="instagram" imageType="square" />
    </a>
    <!-- <a class="social-button">
      <app-image-generator src="/images/icons/telegram.svg" name="telegram" imageType="square" />
    </a>
    <a class="social-button">
      <app-image-generator src="/images/icons/linkedin.svg" name="linkedin" imageType="square" />
    </a>
    <a class="social-button">
      <app-image-generator src="/images/icons/twitter.svg" name="twitter" imageType="square" />
    </a> -->
  </div>
</footer>
